import { inject } from "@angular/core";
import { Router, CanActivateFn, CanActivateChildFn } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SettingsService } from "../../settings.service";
import { of, switchMap } from "rxjs";
import { Feature } from "app/api/models";

export const FeatureGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);
    const snack: MatSnackBar = inject(MatSnackBar);

    var accessDenied = () => 
      snack.open("You do not have access to this page!", "OK", {
        duration: 4000,
      });

    var getFeaturePath = (feature: Feature) => {
      switch(feature) {
        case Feature.HIRE_Customers: return '/hire/customers';
        case Feature.HIRE_Dashboard: return '/hire/dashboard';
        case Feature.HIRE_HireOrders: return '/hire/hire-orders';
        case Feature.HIRE_Calendar: return '/hire/calendar';
        case Feature.HIRE_Assets: return '/hire/assets';
        case Feature.HIRE_Invoicing: return '/hire/invoicing';
        case Feature.HIRE_AssetBoard: return '/hire/asset-board';

        case Feature.CALIB_MyDash: return '/calibration/my-dashboard';
        case Feature.CALIB_AdminDash: return '/calibration/dashboard/admin-dashboard';
        case Feature.CALIB_WorkshopDash: return '/calibration/dashboard/workshop-dashboard';
        case Feature.CALIB_EngineerDash: return '/calibration/dashboard/engineer-dashboard';
        case Feature.CALIB_Servicing: return '/calibration/servicing';
        case Feature.CALIB_Settings: return '/calibration/settings';
        case Feature.CALIB_Customers: return '/calibration/customers';
        case Feature.CALIB_Form10a: return '/calibration/form-10a';
        
        case Feature.CLOCK_ClockingIn: return '/calibration/clocking-in';

        case Feature.SETTINGS_Users: return '/settings/users';
        case Feature.SETTINGS_Roles: return '/settings/roles';
        case Feature.SETTINGS_CompanyDetails: return '/settings/company-details';
        case Feature.SETTINGS_ReleaseNotes: return '/settings/release-notes';

        case Feature.PROJ_Projects: return '/project-management/projects';

        case Feature.CRM_Contacts: return '/crm/contacts';
        case Feature.CRM_Leads: return '/crm/leads';
        case Feature.CRM_Pipeline: return '/crm/pipeline';
        case Feature.CRM_Emails: return '/crm/emails';
        case Feature.CRM_Reporting: return '/crm/reporting';
        case Feature.CRM_SalesOrders: return '/crm/sales-orders';

        case Feature.PROD_Production: return '/production';
        
        default: return 'invalid';
      }
    };

    // Check the authentication status
    return inject(SettingsService).apiSettingsAllowedFeaturesGet$Json$Response().pipe(
        switchMap((res) =>
        {
            var featureList = res?.body?.data;
            // console.log(featureList);

            var allowedPaths = featureList.map(x => getFeaturePath(x));
            // console.log(allowedPaths);
            // console.log(allowedPaths.filter(x => state.url.startsWith(x)))

            if(!featureList || allowedPaths.filter(x => state.url.startsWith(x)).length == 0) {
              accessDenied();

              const urlTree = router.parseUrl(`sign-in`);
              return of(urlTree);
            }

            // Allow the access
            return of(true);
        }),
    );
}
